import { render, staticRenderFns } from "./InputOnlyByNumberFee.vue?vue&type=template&id=4f741b9e&scoped=true"
import script from "./InputOnlyByNumberFee.vue?vue&type=script&lang=js"
export * from "./InputOnlyByNumberFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f741b9e",
  null
  
)

export default component.exports